import * as React from "react"

import { cn } from "../../lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    // Create a mutable ref
    const inputRef = (ref as React.MutableRefObject<HTMLInputElement | null>) || React.useRef<HTMLInputElement>(null)

    // Handle click on the input container for date inputs
    const handleClick = () => {
      if (type === 'date' && inputRef.current) {
        inputRef.current.showPicker()
      }
    }

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-xl border border-brand-border bg-brand-background px-3 py-2 text-sm ring-offset-brand-background transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-light/20 focus-visible:border-brand-border disabled:cursor-not-allowed disabled:opacity-70 dark:border-brand-border dark:bg-brand-background dark:ring-offset-brand-dark dark:text-foreground dark:placeholder:text-muted-foreground dark:focus-visible:border-brand-border dark:focus-visible:ring-brand-light/20",
          type === "time" && "dark:[color-scheme:dark]",
          type === "date" && "[&::-webkit-calendar-picker-indicator]:bg-brand-light dark:[&::-webkit-calendar-picker-indicator]:bg-brand-light [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:right-3 [&::-webkit-datetime-edit-fields-wrapper]:pr-10 relative",
          className
        )}
        ref={inputRef}
        onClick={handleClick}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
